










































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { BrowserTitlesConfig } from './type';

const cssPrefix = 'mswAppTitle';
@Component({
  components: {
    ...UUIFComponents,
  },
})
export default class MswAppTitle extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: String, default: '' })
  readonly pageTitle: any;

  @Prop({ type: String, default: '' })
  readonly pageParentName: any;

  @Prop({ type: String, default: '' })
  readonly tab: any;

  @Prop({ type: Boolean, default: false })
  readonly isShowBackButton: any;

  @Prop({ type: Boolean, default: false })
  readonly isShowSerialNumber: any;

  @Prop({ type: Boolean, default: true })
  readonly isShowDashboardIcon: any;

  @Prop({ type: Boolean, default: false })
  readonly isDisableSerialNumber: any;

  @Prop({ type: String, default: '' })
  readonly theme: any;

  @Prop({ type: Function, default: null })
  readonly backButtonAction: any;

  @Prop({ type: Boolean, default: true })
  readonly isShowSlash: any;

  @Prop({ type: Boolean, default: true })
  readonly isShowParent: any;

  @Prop({ type: Boolean, default: false })
  readonly isShowPrintButtton: any;

  @Watch('isShowSerialNumber')
  private onChangeShowSerialNumberStatus() {
    if (this.isShowSerialNumber === true) {
      this.showSerialNumber = this.isShowSerialNumber;
    }
  }

  @Watch('isShowDashboardIcon')
  private onChangeShowDashboardIconStatus() {
    if (this.isShowDashboardIcon === false) {
      this.showDashboardIcon = this.isShowDashboardIcon;
    }
  }

  @Watch('isDisableSerialNumber')
  private onChangeDisableSerialNumberStatus() {
    if (this.isDisableSerialNumber === true) {
      this.disableSerialNumber = this.isDisableSerialNumber;
    }
  }

  @Watch('isShowParent')
  private onChangeShowParentStatus() {
    if (this.isShowParent === false) {
      this.showParent = this.isShowParent;
    }
  }

  @Watch('pageTitle')
  private onChangePageTitleStatus() {
    if (this.pageTitle !== '') {
      this.title = this.pageTitle;
    }
  }

  @Watch('pageParentName')
  private onChangePageParentNameStatus() {
    if (this.pageParentName !== '') {
      this.parentName = this.pageParentName;
    }
  }

  @Watch('isShowSlash')
  private onChangeShowSlashStatus() {
    if (this.isShowSlash === false) {
      this.showSlash = this.isShowSlash;
    }
  }

  @Watch('isShowPrintButtton')
  private onChangeShowPrintButtton() {
    this.showPrintButtton = this.isShowPrintButtton;
  }

  backButtonActionValue: Function | null = () => {};
  showBackButton: boolean = false;
  showSerialNumber: boolean = false;
  showDashboardIcon: boolean = false;
  disableSerialNumber: boolean = false;
  serialNumber: string = '';
  showSlash: boolean = false;
  showParent: boolean = true;
  title: string = '';
  parentName: string = '';
  showPrintButtton: boolean = false;

  get getPageTitle(): BrowserTitlesConfig {
    return this.$store.getters.getPageTitle || {};
  }

  get getTitle() {
    return this.title;
  }

  get getPageParentName() {
    return this.parentName;
  }

  onClickSerialNumber() {
    this.pushToRoute('/m/feature/products', { serialNumber: this.serialNumber, tab: 'licenses' });
    const redirectUrl: string = `/m/feature/products?serialNumber=${this.serialNumber}&tab=licenses`;
    window.parent.postMessage({ redirectUrl }, '*');
  }

  pushToRoute(routePath: string, routeQuery: any = {}) {
    const subUser = this.$router.currentRoute.query.snbuser ? this.$router.currentRoute.query.snbuser.toString() : '';
    if (subUser && subUser !== '') {
      this.$router.push({ path: routePath, query: { ...routeQuery, snbuser: subUser } })
        .catch((routeError: any) => {
          console.warn(routeError);
        });
    } else {
      this.$router.push({ path: routePath, query: { ...routeQuery } })
        .catch((routeError: any) => {
          console.warn(routeError);
        });
    }
  }

  // back button event listener
  onClickBackButton() {
    this.$emit('on-click-backButton');
  }

  goToHome() {
    if (this.showPrintButtton) {
      return;
    }
    this.$router.push('/m/feature/dashboard');
    const redirectUrl: string = '/m/feature/dashboard';
    window.parent.postMessage({ redirectUrl }, '*');
  }

  initializeValuesFromStore() {
    this.showDashboardIcon = this.getPageTitle?.isShowDashboardIcon || true;
    this.showBackButton = this.getPageTitle?.isShowBackButton ||  false;
    this.backButtonActionValue = this.getPageTitle?.backButtonAction || null;
    this.disableSerialNumber = this.getPageTitle?.isDisableSerialNumber ||  false;
    this.showSlash = this.getPageTitle?.isShowSlash || true;
    this.showSerialNumber = this.getPageTitle?.isShowSerialNumber || false;
    this.showParent = this.getPageTitle?.isShowParent || true;
    this.title = this.getPageTitle?.title || '';
    this.parentName = this.getPageTitle?.parent || '';
  }

  /* Overriding the values of PageTitle Config through the props */
  overrideStatesThroughProps() {
    if (this.isShowDashboardIcon === false) {
      this.showDashboardIcon = this.isShowDashboardIcon;
    }
    if (this.isShowBackButton === true) {
      this.showBackButton = this.isShowBackButton;
    }
    if (this.backButtonAction !== null) {
      this.backButtonActionValue = this.backButtonAction;
    }
    if (this.isDisableSerialNumber === true) {
      this.disableSerialNumber = this.isDisableSerialNumber;
    }
    if (this.isShowSlash === false) {
      this.showSlash = this.isShowSlash;
    }
    if (this.isShowSerialNumber === true) {
      this.showSerialNumber = this.isShowSerialNumber;
    }
    if (!this.isShowParent) {
      this.showParent = this.isShowParent;
    }
    if (this.pageTitle !== '') {
      this.title = this.pageTitle;
    }
    if (this.pageParentName !== '') {
      this.parentName = this.pageParentName;
    }
    if (this.isShowPrintButtton) {
      this.showPrintButtton = this.isShowPrintButtton;
    }
  }

  mounted() {
    if ((this.$route.query.serialNumber || this.$route.query.SERIALNUMBER || this.$route.query.serialnumber)) {
      this.serialNumber = (this.$route.query.serialNumber || this.$route.query.SERIALNUMBER || this.$route.query.serialnumber).toString() || '';
    }
    this.$store.watch(
      // tslint:disable-next-line
      (state, getters) => {
        return getters.getPageTitle;
      },
      // tslint:disable-next-line
      (oldVal, newVal) => {
        this.initializeValuesFromStore();
        this.overrideStatesThroughProps();
      },
      {
        deep: true,
        immediate: true,
      },
    );
  }

  print() {
    window.print();
  }
}
